import { RESET_CATS } from '../types'
export const resetcats = () => {

    return (dispatch) => {
        dispatch({ type: RESET_CATS });
    }
}